// extracted by mini-css-extract-plugin
export default {"deleteConfiguration":"unhandled-error-message-deleteConfiguration-kJYudf","content":"unhandled-error-message-content-JLOz9o"};